var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeleteElementGreyTrue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3257_14232)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.6665 5.11874L6.6665 3.72583C6.6665 2.75517 6.6665 2.26984 6.95768 1.96829C7.24886 1.66675 7.71751 1.66675 8.65481 1.66675L11.3449 1.66675C12.2822 1.66675 12.7508 1.66675 13.042 1.96829C13.3332 2.26984 13.3332 2.75517 13.3332 3.72583V5.11874",
    stroke: "#888888",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0835 9.7627L7.91683 9.7627",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8335 13.0962L9.16683 13.0962",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1782 12.9455C14.9897 14.6521 14.9058 15.3043 14.656 15.7989C14.2877 16.5278 13.6585 17.0913 12.8935 17.3774C12.3745 17.5715 11.7171 17.5833 10 17.5833C8.28302 17.5833 7.62556 17.5715 7.10658 17.3774C6.34163 17.0913 5.71241 16.5278 5.34412 15.7989C5.09425 15.3043 5.01035 14.6521 4.82185 12.9455L3.9747 5.27527L16.0254 5.27527L15.1782 12.9455Z",
    stroke: "#888888",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.10181H17.5",
    stroke: "#888888",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3257_14232"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteElementGreyTrue);
export default __webpack_public_path__ + "static/media/deleteElementGreyTrue.3dbb8a2d2daa613583556d2ca5227e17.svg";
export { ForwardRef as ReactComponent };